import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

// Components
import FormAddress from './oc-form-address';
import FormGroup from './oc-form-group';
import FormName from './oc-form-name';
import EmailInput from '../input-elements/oc-email-input';
import PhoneInput from '../input-elements/oc-phone-input';
import SelectDropdown from '../input-elements/oc-select-dropdown';
import TextInput from '../input-elements/oc-text-input';

const FormContact = ({
  columns,
  states,
  nameRequired = true,
  emailRequired = true,
  phoneRequired = false,
  addressRequired = true,
}) => (
  <>
    <FormName columns={columns} margin="0" required={nameRequired} />

    <FormGroup multipleFields columns={columns} margin="0">
      <div>
        <PhoneInput name="phone" label="Phone" required={phoneRequired} />
      </div>
      <div>
        <EmailInput name="email" label="Email" required={emailRequired} />
      </div>
    </FormGroup>

    <FormAddress columns={columns} states={states} margin="0" required={addressRequired} />
  </>
);

export default FormContact;

FormContact.propTypes = {
  /* CSS: Set to true if you want a 2 column setup */
  columns: PropTypes.bool,
  /* HTML: Determines whether or not the address fields are required */
  addressRequired: PropTypes.bool,
  /* HTML: Determines whether or not the email field is required */
  emailRequired: PropTypes.bool,
  /* HTML: Determines whether or not the name fields are required */
  nameRequired: PropTypes.bool,
  /* HTML: Determines whether or not the phone field is required */
  phoneRequired: PropTypes.bool,
  /* JSX: Array of states for the state field */
  states: PropTypes.array,
};
